module.exports = __webpack_public_path__ + "static/maj_sierpien_2023-10fd69e86410cb2cf397b4bee016726d.pdf";